(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('PasswordResetCtrl', passwordResetCtrl);

    function passwordResetCtrl($scope, $location, $rootScope, UsersAPIService, blockUI, $mdDialog) {
        $rootScope.showHeader = false;
        var username = $location.search().user;
        var token = $location.search().token;
        $scope.userOrTokenError = !username || !token;

        $scope.resetPassword = function () {
            if ($scope.password === $scope.passwordConfirmation) {
                blockUI.start();
                UsersAPIService.resetPassword($scope.password, $scope.passwordConfirmation, username, token)
                    .then(() => {
                        blockUI.stop();

                        $mdDialog
                            .show(
                                $mdDialog
                                    .alert()
                                    .parent(document.body)
                                    .clickOutsideToClose(true)
                                    .title('Password reset')
                                    .textContent('Your new password is ready')
                                    .ok('OK!')
                            )
                            .finally(() => {
                                $location.path('/signin');
                            });
                    })
                    .catch((err) => {
                        blockUI.stop();
                        $mdDialog
                            .show(
                                $mdDialog
                                    .alert()
                                    .parent(document.body)
                                    .clickOutsideToClose(true)
                                    .title('Password reset')
                                    .textContent(err.data.Message)
                                    .ok('OK!')
                            )
                            .finally(() => {
                                $location.path('/signin');
                            });
                    });
            } else {
                $mdDialog.show(
                    $mdDialog
                        .alert()
                        .parent(document.body)
                        .clickOutsideToClose(true)
                        .title('Password error')
                        .textContent("Passwords don't match")
                        .ok('OK!')
                );
            }
        };
    }
})();
